import { ROLE_LABELS } from '@/types/role'
import type { Role } from '@/types/role'

export function isEngineerRole(role: string | null | undefined): boolean {
  return role === 'engineer'
}

export function personDisplayName(first?: string | null, last?: string | null, email?: string | null): string {
  const name = `${(first || '').trim()} ${(last || '').trim()}`.trim()
  return name || (email || '').trim() || 'Unbekannt'
}

export function engineerPublicLabel(name: string, role: string | null | undefined): string {
  if (isEngineerRole(role)) {
    const base = name.replace(/\s*\(Engineer\)\s*$/i, '').trim()
    return `${base} (Engineer)`
  }
  return name
}

export function publicRoleCaption(role: string): string {
  if (isEngineerRole(role)) return 'Engineer'
  if (role === 'ultraadmin') return ''
  return ROLE_LABELS[role as Role] || role
}
